"use client";
import React, { useState } from "react";
import { Button } from "~/components/v4/themed/Button";
import { cn } from "~/utils/fontsConfig";
import SuggestCommunityModal from "./SuggestCommunityModal";
import { GetWaitlistCommunities } from "../actions";

type Props = {
    variant?:
        | "default"
        | "secondary"
        | "tertiary"
        | "primaryLink"
        | "secondaryLink"
        | "destructive"
        | "info"
        | "ghost"
        | "slider"
        | "link"
        | "tabPrimary"
        | "admin";
    title?: string;
    communities: GetWaitlistCommunities;
};

const SuggestACommunity = ({
    variant = "secondary",
    title,
    communities,
}: Props) => {
    const [isCommunityCreateVisible, setIsCommunityCreateVisible] =
        useState(false);

    return (
        <div className="inline-flex">
            <Button
                variant={variant}
                className={cn(
                    variant === "primaryLink" ? "m-0 inline p-0" : "",
                )}
                onClick={() => {
                    setIsCommunityCreateVisible(true);
                }}
            >
                Suggest a community
            </Button>
            <SuggestCommunityModal
                communities={communities}
                isOpen={isCommunityCreateVisible}
                onClose={() => {
                    setIsCommunityCreateVisible(false);
                }}
            />
        </div>
    );
};

export default SuggestACommunity;
